// 手机号正则
export const RE_PHONE_NUMBER = /^(?:(?:\+|00)86)?1[3-9]\d{9}$/;

// 富文本编辑器中的视频占位图
export const RE_RICHTEXT_VIDEO_PLACEHOLDER = /<img\s+?[^>]*?data-custom=['"]video=([^>]+?)&amp;poster=([^>]+?)['"][^>]*?>/ig;

// 富文本编辑器中的video标签
export const RE_RICHTEXT_VIDEO_TAG = /<video\s+?src=['"]([^>]+?)['"]\s+?poster=['"]([^>]+?)['"]\s*?>[^>]\s+?controls*?<\/video>/ig;
export const RE_RICHTEXT_VIDEO_TAG_S = /<video\s+[^>]*?src=['"]([^"']+?)["'][^>]*?poster=['"]([^"']+?)["'][^>]*?\>(.*?)<\/video>/ig

export let NBSP = /<p>&nbsp;<\/p>/g
export const LETTER_NUMBER = /[^A-Za-z0-9]/g //输入字母和数字组合
export const LETTER_NUMBER_LOG = /^(?=.*[a-zA-Z])(?=.*\d).+$/ // 登录 字母和数字组合
export const LETTER_NUMBER_PASSWORD = /^[a-zA-Z0-9]{6,20}$/ //密码